import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class TeamsArchivedTeamsTableIndexComponent extends Component {
  @service intl;
  @service('teams') teamsService;

  get columns() {
    if (this.args?.columns) return this.args?.columns;

    return [
      {
        name: this.intl.t('_teams.name'),
        valuePath: 'name',
        class: '!w-[90%]',
        key: 'name',
        component: 'teams/active-teams/table-cell/title',
        test_id: 'team-name',
      },
      {
        name: '',
        valuePath: 'restore',
        class: '!w-[10%]',
        key: 'restore',
        component: 'button',
        type: 'primary',
        test_id: 'restore',
      },
    ];
  }

  @action
  restoreTeam(team_id) {
    this.teamsService.restoreTeam(team_id);
  }

  get rows() {
    if (this.args?.rows) return this.args.rows;
    return this.args?.teams.map((item) => this.convertTeamItemToRow(item));
  }

  convertTeamItemToRow(item) {
    return {
      name: item,
      restore: {
        label: this.intl.t('_teams.restore'),
        onClick: () => this.restoreTeam(item.id),
      },
    };
  }
}
